export default __webpack_public_path__ + "static/media/Rammy.649da680.jpg";